export const AliasType = {
  physical:          "Physical",
  network:           "Network",
  WebDav:            "WebDav",
  s3Bucket:          "S3Bucket",
  googleCloudBucket: "GoogleCloudBucket",
  azureContainer:    "AzureContainer",
  genericS3:         "GenericS3"
};

export const AliasTypeNames = {
  Physical:          "Physical",
  Network:           "Network",
  S3Bucket:          "S3 Bucket",
  GenericS3:         "Generic S3",
  WebDav:            "WebDav",
  GoogleCloudBucket: "Google Cloud Bucket",
  AzureContainer:    "Azure Container",
}

export const HttpTypes = new Set([AliasType.WebDav])

export const AllAliasTypes = Object.entries(AliasTypeNames);
